import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes sentía ansiedad cada vez que veía noticias sobre crisis o apagones… ahora siento que mi hogar está mucho más preparado.',
  name: 'Marina R.',
  role: 'Buenos Aires'
}, {
  quote: 'Me ayudó a organizar agua, alimentos y un plan familiar sin volverme paranoico.',
  name: 'Pablo G.',
  role: 'Córdoba'
}, {
  quote: 'Nunca pensé que iba a necesitar estas herramientas… hasta que hubo cortes de luz y problemas de abastecimiento.',
  name: 'Luciana T.',
  role: 'Rosario'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-303">
      <div className="max-w-xl mx-auto" data-id="element-304">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-305">
          💬 ¿Qué dicen las personas que ya usan el MegaPack?
        </h2>

        <div className="space-y-4" data-id="element-306">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 p-5 rounded-xl transition-all hover:bg-white/10" data-id="element-307">
              <div className="flex gap-0.5 mb-3" data-id="element-308">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-309" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-310">
                "{t.quote}"
              </p>
              <div data-id="element-311">
                <p className="font-bold text-white text-sm" data-id="element-312">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-313">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}